import { render } from "./DbsMyBooking.vue?vue&type=template&id=62b6b4bb"
import script from "./DbsMyBooking.vue?vue&type=script&lang=js"
export * from "./DbsMyBooking.vue?vue&type=script&lang=js"
script.render = render

export default script